import React from "react";

import "./css/App.css";

import Gamepage from "./pages/Gamepage";
import AllRoutes from "./routes/AllRoutes";

function App() {
  return (
    <div className="App">
      <AllRoutes />
      {/* <Gamepage /> */}

    </div>
  );
}

export default App;
